import "./visa.css";
import Topbar from "../../components/Topbar/Topbar";
import React, { useState, useEffect } from "react";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import API from '../../API'
import { ClipLoader } from "react-spinners";
import {
  FaPassport, FaUser, FaUsers, FaGlobeAmericas, FaFileAlt, FaCalendarAlt,
  FaEnvelope, FaMapMarkerAlt, FaIdCard, FaUpload, FaCheckCircle, FaInfoCircle,
  FaFileUpload, FaFlag, FaPlane, FaShieldAlt
} from "react-icons/fa";

import Modal from 'react-modal';
import { X } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const visaTypes = [
  { value: "TOURIST", label: "Tourist Visa" },
  { value: "BUSINESS", label: "Business Visa" },
  { value: "STUDENT", label: "Student Visa" },
  { value: "WORK", label: "Work Visa" },
];

const countries = [
  { value: "algeria", label: "Algeria" },
  { value: "afghanistan", label: "Afghanistan" },
  { value: "albania", label: "Albania" },

  { value: "andorra", label: "Andorra" },
  { value: "angola", label: "Angola" },
  { value: "argentina", label: "Argentina" },
  { value: "armenia", label: "Armenia" },
  { value: "australia", label: "Australia" },
  { value: "austria", label: "Austria" },
  { value: "azerbaijan", label: "Azerbaijan" },
  { value: "bahamas", label: "Bahamas" },
  { value: "bahrain", label: "Bahrain" },
  { value: "bangladesh", label: "Bangladesh" },
  { value: "barbados", label: "Barbados" },
  { value: "belarus", label: "Belarus" },
  { value: "belgium", label: "Belgium" },
  { value: "belize", label: "Belize" },
  { value: "benin", label: "Benin" },
  { value: "bhutan", label: "Bhutan" },
  { value: "bolivia", label: "Bolivia" },
  { value: "bosnia_and_herzegovina", label: "Bosnia and Herzegovina" },
  { value: "botswana", label: "Botswana" },
  { value: "brazil", label: "Brazil" },
  { value: "brunei", label: "Brunei" },
  { value: "bulgaria", label: "Bulgaria" },
  { value: "burkina_faso", label: "Burkina Faso" },
  { value: "burundi", label: "Burundi" },
  { value: "cambodia", label: "Cambodia" },
  { value: "cameroon", label: "Cameroon" },
  { value: "canada", label: "Canada" },
  { value: "cape_verde", label: "Cape Verde" },
  { value: "chad", label: "Chad" },
  { value: "chile", label: "Chile" },
  { value: "china", label: "China" },
  { value: "colombia", label: "Colombia" },
  { value: "comoros", label: "Comoros" },
  { value: "congo", label: "Congo" },
  { value: "costa_rica", label: "Costa Rica" },
  { value: "croatia", label: "Croatia" },
  { value: "cuba", label: "Cuba" },
  { value: "cyprus", label: "Cyprus" },
  { value: "czech_republic", label: "Czech Republic" },
  { value: "denmark", label: "Denmark" },
  { value: "djibouti", label: "Djibouti" },
  { value: "dominica", label: "Dominica" },
  { value: "dominican_republic", label: "Dominican Republic" },
  { value: "ecuador", label: "Ecuador" },
  { value: "egypt", label: "Egypt" },
  { value: "el_salvador", label: "El Salvador" },
  { value: "equatorial_guinea", label: "Equatorial Guinea" },
  { value: "eritrea", label: "Eritrea" },
  { value: "estonia", label: "Estonia" },
  { value: "eswatini", label: "Eswatini" },
  { value: "ethiopia", label: "Ethiopia" },
  { value: "fiji", label: "Fiji" },
  { value: "finland", label: "Finland" },
  { value: "france", label: "France" },
  { value: "gabon", label: "Gabon" },
  { value: "gambia", label: "Gambia" },
  { value: "georgia", label: "Georgia" },
  { value: "germany", label: "Germany" },
  { value: "ghana", label: "Ghana" },
  { value: "greece", label: "Greece" },
  { value: "grenada", label: "Grenada" },
  { value: "guatemala", label: "Guatemala" },
  { value: "guinea", label: "Guinea" },
  { value: "guyana", label: "Guyana" },
  { value: "haiti", label: "Haiti" },
  { value: "honduras", label: "Honduras" },
  { value: "hungary", label: "Hungary" },
  { value: "iceland", label: "Iceland" },
  { value: "india", label: "India" },
  { value: "indonesia", label: "Indonesia" },
  { value: "iran", label: "Iran" },
  { value: "iraq", label: "Iraq" },
  { value: "ireland", label: "Ireland" },
  { value: "italy", label: "Italy" },
  { value: "ivory_coast", label: "Ivory Coast" },
  { value: "jamaica", label: "Jamaica" },
  { value: "japan", label: "Japan" },
  { value: "jordan", label: "Jordan" },
  { value: "kazakhstan", label: "Kazakhstan" },
  { value: "kenya", label: "Kenya" },
  { value: "kiribati", label: "Kiribati" },
  { value: "kuwait", label: "Kuwait" },
  { value: "kyrgyzstan", label: "Kyrgyzstan" },
  { value: "laos", label: "Laos" },
  { value: "latvia", label: "Latvia" },
  { value: "lebanon", label: "Lebanon" },
  { value: "lesotho", label: "Lesotho" },
  { value: "liberia", label: "Liberia" },
  { value: "libya", label: "Libya" },
  { value: "liechtenstein", label: "Liechtenstein" },
  { value: "lithuania", label: "Lithuania" },
  { value: "luxembourg", label: "Luxembourg" },
  { value: "madagascar", label: "Madagascar" },
  { value: "malawi", label: "Malawi" },
  { value: "malaysia", label: "Malaysia" },
  { value: "maldives", label: "Maldives" },
  { value: "mali", label: "Mali" },
  { value: "malta", label: "Malta" },
  { value: "mauritania", label: "Mauritania" },
  { value: "mauritius", label: "Mauritius" },
  { value: "mexico", label: "Mexico" },
  { value: "monaco", label: "Monaco" },
  { value: "mongolia", label: "Mongolia" },
  { value: "montenegro", label: "Montenegro" },
  { value: "morocco", label: "Morocco" },
  { value: "mozambique", label: "Mozambique" },
  { value: "myanmar", label: "Myanmar" },
  { value: "namibia", label: "Namibia" },
  { value: "nepal", label: "Nepal" },
  { value: "netherlands", label: "Netherlands" },
  { value: "new_zealand", label: "New Zealand" },
  { value: "nigeria", label: "Nigeria" },
  { value: "norway", label: "Norway" },
  { value: "oman", label: "Oman" },
  { value: "pakistan", label: "Pakistan" },
  { value: "panama", label: "Panama" },
  { value: "peru", label: "Peru" },
  { value: "philippines", label: "Philippines" },
  { value: "poland", label: "Poland" },
  { value: "portugal", label: "Portugal" },
  { value: "qatar", label: "Qatar" },
  { value: "romania", label: "Romania" },
  { value: "russia", label: "Russia" },
  { value: "rwanda", label: "Rwanda" },
  { value: "saudi_arabia", label: "Saudi Arabia" },
  { value: "senegal", label: "Senegal" },
  { value: "serbia", label: "Serbia" },
  { value: "seychelles", label: "Seychelles" },
  { value: "singapore", label: "Singapore" },
  { value: "slovakia", label: "Slovakia" },
  { value: "slovenia", label: "Slovenia" },
  { value: "somalia", label: "Somalia" },
  { value: "south_africa", label: "South Africa" },
  { value: "south_korea", label: "South Korea" },
  { value: "spain", label: "Spain" },
  { value: "sri_lanka", label: "Sri Lanka" },
  { value: "sudan", label: "Sudan" },
  { value: "sweden", label: "Sweden" },
  { value: "switzerland", label: "Switzerland" },
  { value: "syria", label: "Syria" },
  { value: "taiwan", label: "Taiwan" },
  { value: "tajikistan", label: "Tajikistan" },
  { value: "tanzania", label: "Tanzania" },
  { value: "thailand", label: "Thailand" },
  { value: "togo", label: "Togo" },
  { value: "tunisia", label: "Tunisia" },
  { value: "turkey", label: "Turkey" },
  { value: "uganda", label: "Uganda" },
  { value: "ukraine", label: "Ukraine" },
  { value: "united_arab_emirates", label: "United Arab Emirates" },
  { value: "united_kingdom", label: "United Kingdom" },
  { value: "united_states", label: "United States" },
  { value: "uruguay", label: "Uruguay" },
  { value: "uzbekistan", label: "Uzbekistan" },
  { value: "vanuatu", label: "Vanuatu" },
  { value: "venezuela", label: "Venezuela" },
  { value: "vietnam", label: "Vietnam" },
  { value: "yemen", label: "Yemen" },
  { value: "zambia", label: "Zambia" },
  { value: "zimbabwe", label: "Zimbabwe" },
];


const documentTypes = [
  { value: "PASSPORT", label: "Passport" },
];



const nationalities = [
  { value: "algerian", label: "Algerian" },
  { value: "afghan", label: "Afghan" },
  { value: "albanian", label: "Albanian" },

  { value: "andorran", label: "Andorran" },
  { value: "angolan", label: "Angolan" },
  { value: "argentine", label: "Argentine" },
  { value: "armenian", label: "Armenian" },
  { value: "australian", label: "Australian" },
  { value: "austrian", label: "Austrian" },
  { value: "azerbaijani", label: "Azerbaijani" },
  { value: "bahamian", label: "Bahamian" },
  { value: "bahraini", label: "Bahraini" },
  { value: "bangladeshi", label: "Bangladeshi" },
  { value: "barbadian", label: "Barbadian" },
  { value: "belarusian", label: "Belarusian" },
  { value: "belgian", label: "Belgian" },
  { value: "belizean", label: "Belizean" },
  { value: "beninese", label: "Beninese" },
  { value: "bhutanese", label: "Bhutanese" },
  { value: "bolivian", label: "Bolivian" },
  { value: "bosnian", label: "Bosnian" },
  { value: "botswanan", label: "Botswanan" },
  { value: "brazilian", label: "Brazilian" },
  { value: "bruneian", label: "Bruneian" },
  { value: "bulgarian", label: "Bulgarian" },
  { value: "burkinabe", label: "Burkinabé" },
  { value: "burundian", label: "Burundian" },
  { value: "cambodian", label: "Cambodian" },
  { value: "cameroonian", label: "Cameroonian" },
  { value: "canadian", label: "Canadian" },
  { value: "cape_verdean", label: "Cape Verdean" },
  { value: "chadian", label: "Chadian" },
  { value: "chilean", label: "Chilean" },
  { value: "chinese", label: "Chinese" },
  { value: "colombian", label: "Colombian" },
  { value: "comoran", label: "Comoran" },
  { value: "congolese", label: "Congolese" },
  { value: "costa_rican", label: "Costa Rican" },
  { value: "croatian", label: "Croatian" },
  { value: "cuban", label: "Cuban" },
  { value: "cypriot", label: "Cypriot" },
  { value: "czech", label: "Czech" },
  { value: "danish", label: "Danish" },
  { value: "djiboutian", label: "Djiboutian" },
  { value: "dominican", label: "Dominican" },
  { value: "ecuadorian", label: "Ecuadorian" },
  { value: "egyptian", label: "Egyptian" },
  { value: "salvadoran", label: "Salvadoran" },
  { value: "equatorial_guinean", label: "Equatorial Guinean" },
  { value: "eritrean", label: "Eritrean" },
  { value: "estonian", label: "Estonian" },
  { value: "eswatini", label: "Eswatini" },
  { value: "ethiopian", label: "Ethiopian" },
  { value: "fijian", label: "Fijian" },
  { value: "finnish", label: "Finnish" },
  { value: "french", label: "French" },
  { value: "gabonese", label: "Gabonese" },
  { value: "gambian", label: "Gambian" },
  { value: "georgian", label: "Georgian" },
  { value: "german", label: "German" },
  { value: "ghanaian", label: "Ghanaian" },
  { value: "greek", label: "Greek" },
  { value: "grenadian", label: "Grenadian" },
  { value: "guatemalan", label: "Guatemalan" },
  { value: "guinean", label: "Guinean" },
  { value: "guyanese", label: "Guyanese" },
  { value: "haitian", label: "Haitian" },
  { value: "honduran", label: "Honduran" },
  { value: "hungarian", label: "Hungarian" },
  { value: "icelandic", label: "Icelandic" },
  { value: "indian", label: "Indian" },
  { value: "indonesian", label: "Indonesian" },
  { value: "iranian", label: "Iranian" },
  { value: "iraqi", label: "Iraqi" },
  { value: "irish", label: "Irish" },
  { value: "Palestinian", label: "Palestinian" },
  { value: "italian", label: "Italian" },
  { value: "ivorian", label: "Ivorian" },
  { value: "jamaican", label: "Jamaican" },
  { value: "japanese", label: "Japanese" },
  { value: "jordanian", label: "Jordanian" },
  { value: "kazakh", label: "Kazakh" },
  { value: "kenyan", label: "Kenyan" },
  { value: "kiribati", label: "Kiribati" },
  { value: "kuwaiti", label: "Kuwaiti" },
  { value: "kyrgyz", label: "Kyrgyz" },
  { value: "laotian", label: "Laotian" },
  { value: "latvian", label: "Latvian" },
  { value: "lebanese", label: "Lebanese" },
  { value: "lesotho", label: "Lesotho" },
  { value: "liberian", label: "Liberian" },
  { value: "libyan", label: "Libyan" },
  { value: "liechtensteiner", label: "Liechtensteiner" },
  { value: "lithuanian", label: "Lithuanian" },
  { value: "luxembourgish", label: "Luxembourgish" },
  { value: "madagascan", label: "Madagascan" },
  { value: "malawian", label: "Malawian" },
  { value: "malaysian", label: "Malaysian" },
  { value: "maldivian", label: "Maldivian" },
  { value: "malian", label: "Malian" },
  { value: "maltese", label: "Maltese" },
  { value: "mauritanian", label: "Mauritanian" },
  { value: "mauritian", label: "Mauritian" },
  { value: "mexican", label: "Mexican" },
  { value: "monacan", label: "Monacan" },
  { value: "mongolian", label: "Mongolian" },
  { value: "montenegrin", label: "Montenegrin" },
  { value: "moroccan", label: "Moroccan" },
  { value: "mozambican", label: "Mozambican" },
  { value: "myanmarese", label: "Myanmarese" },
  { value: "namibian", label: "Namibian" },
  { value: "nepalese", label: "Nepalese" },
  { value: "dutch", label: "Dutch" },
  { value: "new_zealander", label: "New Zealander" },
  { value: "nigerian", label: "Nigerian" },
  { value: "norwegian", label: "Norwegian" },
  { value: "omani", label: "Omani" },
  { value: "pakistani", label: "Pakistani" },
  { value: "panamanian", label: "Panamanian" },
  { value: "peruvian", label: "Peruvian" },
  { value: "philippine", label: "Philippine" },
  { value: "polish", label: "Polish" },
  { value: "portuguese", label: "Portuguese" },
  { value: "qatari", label: "Qatari" },
  { value: "romanian", label: "Romanian" },
  { value: "russian", label: "Russian" },
  { value: "rwandan", label: "Rwandan" },
  { value: "saudi", label: "Saudi" },
  { value: "senegalese", label: "Senegalese" },
  { value: "serbian", label: "Serbian" },
  { value: "seychellois", label: "Seychellois" },
  { value: "singaporean", label: "Singaporean" },
  { value: "slovak", label: "Slovak" },
  { value: "slovenian", label: "Slovenian" },
  { value: "somali", label: "Somali" },
  { value: "south_african", label: "South African" },
  { value: "south_korean", label: "South Korean" },
  { value: "spanish", label: "Spanish" },
  { value: "sri_lankan", label: "Sri Lankan" },
  { value: "sudanese", label: "Sudanese" },
  { value: "swedish", label: "Swedish" },
  { value: "swiss", label: "Swiss" },
  { value: "syrian", label: "Syrian" },
  { value: "taiwanese", label: "Taiwanese" },
  { value: "tajik", label: "Tajik" },
  { value: "tanzanian", label: "Tanzanian" },
  { value: "thai", label: "Thai" },
  { value: "togolese", label: "Togolese" },
  { value: "tunisian", label: "Tunisian" },
  { value: "turkish", label: "Turkish" },
  { value: "ugandan", label: "Ugandan" },
  { value: "ukrainian", label: "Ukrainian" },
  { value: "emirati", label: "Emirati" },
  { value: "british", label: "British" },
  { value: "american", label: "American" },
  { value: "uruguayan", label: "Uruguayan" },
  { value: "uzbek", label: "Uzbek" },
  { value: "vanuatu", label: "Vanuatuan" },
  { value: "venezuelan", label: "Venezuelan" },
  { value: "vietnamese", label: "Vietnamese" },
  { value: "yemeni", label: "Yemeni" },
  { value: "zambian", label: "Zambian" },
  { value: "zimbabwean", label: "Zimbabwean" },
];


const PrivacyTermsModal = ({ isOpen, onClose, onAccept }) => {
  const { t } = useTranslation();

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      className="v-modal"
      overlayClassName="v-modal-overlay"
      contentLabel={t("visa.privacy_policy_link")}
      ariaHideApp={false}
    >
      <div className="v-modal__head">
        <div className="v-modal__title">
          <FaShieldAlt />
          <h2>{t("visa.privacy_policy_link")}</h2>
        </div>
        <button className="v-modal__close" onClick={onClose} aria-label="close">
          <X size={20} />
        </button>
      </div>
      <div className="v-modal__body">
        {[0, 2, 4].map((i, n) => (
          <div key={n} className="v-term-block">
            <span className="v-term-block__num">{n + 1}</span>
            <div>
              <h3>{t(`visa.terms_content.${i}`)}</h3>
              <p>{t(`visa.terms_content.${i + 1}`)}</p>
            </div>
          </div>
        ))}
      </div>
      <div className="v-modal__foot">
        <button className="v-modal__accept" onClick={onAccept}>
          <FaCheckCircle /> {t("visa.accept_terms_label")}
        </button>
      </div>
    </Modal>
  );
};

const FileField = ({ id, label, value, onChange, icon }) => {
  const { t } = useTranslation();
  const hasFile = !!value;
  return (
    <div className={`v-file ${hasFile ? 'v-file--done' : ''}`}>
      <div className="v-file__icon">{icon || <FaFileUpload />}</div>
      <div className="v-file__body">
        <p className="v-file__label">{label}</p>
        <p className={`v-file__name ${hasFile ? '' : 'v-file__name--empty'}`}>
          {hasFile ? value.name : t("visa.no_file_selected")}
        </p>
      </div>
      <button type="button" className="v-file__btn" onClick={() => document.getElementById(id).click()}>
        <FaUpload /> {t("visa.browse_button")}
      </button>
      <input id={id} type="file" style={{ display: 'none' }} onChange={onChange} />
    </div>
  );
};

const VField = ({ icon: Icon, label, children }) => (
  <div className="v-field">
    <label className="v-label">
      <Icon className="v-label__icon" />
      <span className="v-label__text">{label}</span>
    </label>
    {children}
  </div>
);

const ApplicantForm = ({ index, onChange, values }) => {
  const { t } = useTranslation();
  const set = (field) => (e) => onChange(index, field, e.target.value);

  return (
    <div className="v-applicant">
      <div className="v-applicant__head">
        <span className="v-chip">
          <span className="v-chip__icon"><FaUser /></span>
          #{index + 1}
        </span>
        <h3 className="v-applicant__title">{t("visa.applicant_title", { index: index + 1 })}</h3>
      </div>

      <div className="v-form">
        <VField icon={FaUser} label={t("visa.name_label")}>
          <input className="v-input" type="text" placeholder={t("visa.name_placeholder")} value={values.name || ''} required onChange={set('name')} />
        </VField>
        <VField icon={FaUser} label={t("visa.surname_label")}>
          <input className="v-input" type="text" placeholder={t("visa.surname_placeholder")} value={values.secondname || ''} required onChange={set('secondname')} />
        </VField>
        <VField icon={FaMapMarkerAlt} label={t("visa.birthplace_label")}>
          <input className="v-input" type="text" placeholder={t("visa.birthplace_placeholder")} value={values.birthplace || ''} required onChange={set('birthplace')} />
        </VField>
        <VField icon={FaCalendarAlt} label={t("visa.birthdate_placeholder")}>
          <div className="v-date">
            <DatePicker
              selected={values.birthdate ? new Date(values.birthdate) : null}
              onChange={(date) => onChange(index, 'birthdate', date.toISOString().split("T")[0])}
              placeholderText={t("visa.birthdate_placeholder")}
              dateFormat="yyyy-MM-dd"
              showMonthDropdown showYearDropdown dropdownMode="select"
              openToDate={values.birthdate ? new Date(values.birthdate) : new Date(2000, 0, 1)}
              minDate={new Date(1900, 0, 1)}
              maxDate={new Date()}
              required
            />
          </div>
        </VField>
        <VField icon={FaIdCard} label={t("visa.passport_label")}>
          <input
            className="v-input"
            type="text"
            placeholder={t("visa.passport_placeholder")}
            value={values.nopassport || ''}
            required
            pattern="[A-Za-z0-9]{6,9}"
            title="Passport number: 6–9 letters or digits"
            maxLength={9}
            onChange={(e) => {
              // force uppercase alphanumeric
              const v = (e.target.value || '').replace(/[^A-Za-z0-9]/g, '').toUpperCase().slice(0, 9);
              onChange(index, 'nopassport', v);
            }}
          />
        </VField>
        <VField icon={FaCalendarAlt} label={t("visa.passport_expiration_placeholder")}>
          <div className="v-date">
            <DatePicker
              selected={values.expirationdate ? new Date(values.expirationdate) : null}
              onChange={(date) => onChange(index, 'expirationdate', date.toISOString().split("T")[0])}
              placeholderText={t("visa.passport_expiration_placeholder")}
              dateFormat="yyyy-MM-dd"
              showMonthDropdown showYearDropdown dropdownMode="select"
              minDate={new Date()}
              maxDate={new Date(new Date().getFullYear() + 8, new Date().getMonth(), new Date().getDate())}
              required
            />
          </div>
        </VField>
        <div className="v-field v-field--full">
          <label className="v-label">
            <FaEnvelope className="v-label__icon" />
            <span className="v-label__text">{t("visa.email_label")}</span>
          </label>
          <input className="v-input" type="email" placeholder={t("visa.email_placeholder")} value={values.emailadress || ''} required onChange={set('emailadress')} />
        </div>
      </div>

      <div className="v-docs">
        <div className="v-docs__head">
          <FaFileAlt />
          <h4>{t("visa.documents_title", { index: index + 1 })}</h4>
        </div>
        <div className="v-docs__grid">
          <FileField id={`file1-${index}`} label={t("visa.passport_scan_label")} value={values.file1} icon={<FaPassport />} onChange={(e) => onChange(index, 'file1', e.target.files[0])} />
          <FileField id={`file2-${index}`} label={t("visa.photo_scan_label")} value={values.file2} icon={<FaUser />} onChange={(e) => onChange(index, 'file2', e.target.files[0])} />
          <FileField id={`file3-${index}`} label={t("visa.birth_certificate_scan_label")} value={values.file3} icon={<FaFileAlt />} onChange={(e) => onChange(index, 'file3', e.target.files[0])} />
        </div>
        <div className="v-docs__note">
          <FaInfoCircle />
          <p>{t("visa.file_requirements")}</p>
        </div>
      </div>
    </div>
  );
};

export default function Visa() {
  const { t,i18n  } = useTranslation(); // Initialize the translation hook
  const isRTL = i18n.language === 'ar'; // Assuming 'ar' is your Arabic language code
  const [isPrivacyModalOpen, setIsPrivacyModalOpen] = useState(false);
  const [privacyAccepted, setPrivacyAccepted] = useState(false);
  const [errormessage, setErrormessage] = useState('');
  const [loadingMessage, setLoadingMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [nopersonne, setNopersonne] = useState(1);
  const [visatype, setVisatype] = useState(visaTypes[0]);
  const [startDate, setStartDate] = useState('');
  const [nationality, setNationality] = useState(nationalities[0]);
  const [documentTypev, setDocumentType] = useState(documentTypes[0]);
  const [paymentCountry, setPaymentCountry] = useState(countries[0]);
  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const [applicants, setApplicants] = useState([{
    name: '',
    secondname: '',
    birthplace: '',
    birthdate: '',
    nopassport: '',
    expirationdate: '',
    emailadress: '',
    file1: null,
    file2: null,
    file3: null
  }]);

  // Redirect unauthenticated users to login before they fill anything
  useEffect(() => {
    if (!localStorage.getItem('protoken')) {
      const next = encodeURIComponent(window.location.pathname + window.location.search);
      window.location.href = `/login?next=${next}`;
    }
  }, []);

  const handleApplicantChange = (index, field, value) => {
    const newApplicants = [...applicants];
    newApplicants[index] = {
      ...newApplicants[index],
      [field]: value
    };
    setApplicants(newApplicants);
  };

  const handleNumberOfPersonsChange = (e) => {
    const newNumber = Number(e.target.value);
    setNopersonne(newNumber);

    const updatedApplicants = applicants.slice(0, newNumber);
    while (updatedApplicants.length < newNumber) {
      updatedApplicants.push({
        name: '',
        secondname: '',
        birthplace: '',
        birthdate: '',
        nopassport: '',
        expirationdate: '',
        emailadress: '',
        file1: null,
        file2: null,
        file3: null,
      });
    }
    setApplicants(updatedApplicants);
  };

  const notifySuccess = (message) => 
    toast.success(message, {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });

  const notifyError = (message) => 
    toast.error(message, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });

  const notifyWarning = (message) => 
    toast.warn(message, {
      position: "top-right",
      autoClose: 4000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });

  const isValidDate = (dateString) => {
    const regex = /^\d{4}-\d{2}-\d{2}$/;
    if (!regex.test(dateString)) {
      return false;
    }
    const date = new Date(dateString);
    const [year, month, day] = dateString.split("-");
    return (
      date &&
      date.getFullYear() === parseInt(year, 10) &&
      date.getMonth() + 1 === parseInt(month, 10) &&
      date.getDate() === parseInt(day, 10)
    );
  };

  const handleSubmit = async () => {
    const token = localStorage.getItem('protoken');
    if (!token) {
      notifyError(t("visa.error_messages.login_required"));
      return;
    }

    if (!isValidDate(startDate)) {
      setErrormessage(t("visa.error_messages.invalid_date"));
      setLoading(false);
      return;
    }

    if (!acceptedTerms) {
      setErrormessage(t("visa.error_messages.terms_not_accepted"));
      setLoading(false);
      return;
    }

    for (let i = 0; i < applicants.length; i++) {
      const applicant = applicants[i];
      if (!applicant.name.trim()) {
        notifyError(t("visa.error_messages.required_field", { field: t("visa.name_label"), index: i + 1 }));
        return;
      }
      if (!applicant.secondname.trim()) {
        notifyError(t("visa.error_messages.required_field", { field: t("visa.surname_label"), index: i + 1 }));
        return;
      }
      if (!applicant.birthplace.trim()) {
        notifyError(t("visa.error_messages.required_field", { field: t("visa.birthplace_label"), index: i + 1 }));
        return;
      }
      if (!isValidDate(applicant.birthdate)) {
        notifyError(t("visa.error_messages.invalid_date"));
        return;
      }
      if (!applicant.nopassport.trim()) {
        notifyError(t("visa.error_messages.required_field", { field: t("visa.passport_label"), index: i + 1 }));
        return;
      }
      if (!/^[A-Z0-9]{6,9}$/i.test(applicant.nopassport.trim())) {
        notifyError(`Passport number for applicant ${i + 1} must be 6–9 letters or digits.`);
        return;
      }
      if (!isValidDate(applicant.expirationdate)) {
        notifyError(t("visa.error_messages.invalid_date"));
        return;
      }
      if (!applicant.emailadress.trim()) {
        notifyError(t("visa.error_messages.required_field", { field: t("visa.email_label"), index: i + 1 }));
        return;
      }
      if (!/\S+@\S+\.\S+/.test(applicant.emailadress)) {
        notifyError(t("visa.error_messages.invalid_email", { index: i + 1 }));
        return;
      }
    }

    const formData = new FormData();
    formData.append("numPersons", nopersonne);
    formData.append("visaType", visatype.value);
    formData.append("startDate", startDate);
    formData.append("nationality", nationality.value);
    formData.append("travelDocument", documentTypev.value);
    formData.append("country", paymentCountry.value);
    formData.append("acceptedTerms", acceptedTerms);

    applicants.forEach((applicant, index) => {
      formData.append(`applicants[${index}][name]`, applicant.name);
      formData.append(`applicants[${index}][surname]`, applicant.secondname);
      formData.append(`applicants[${index}][birthPlace]`, applicant.birthplace);
      formData.append(`applicants[${index}][birthDate]`, applicant.birthdate);
      formData.append(`applicants[${index}][passportNumber]`, applicant.nopassport);
      formData.append(`applicants[${index}][expirationDate]`, applicant.expirationdate);
      formData.append(`applicants[${index}][email]`, applicant.emailadress);
      
      if (applicant.file1) formData.append(`applicants[${index}][passportScan]`, applicant.file1);
      if (applicant.file2) formData.append(`applicants[${index}][photoScan]`, applicant.file2);
      if (applicant.file3) formData.append(`applicants[${index}][birthCertScan]`, applicant.file3);
    });

    const userId = localStorage.getItem('userId');
    formData.append("userId", userId);

    try {
      const token = localStorage.getItem('protoken');
      if (!token) {
        notifyError(t("visa.error_messages.login_required"));
        return;
      }

      const response = await API.post('/visas', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${token}`, 
        },
      });
      setLoadingMessage(t("visa.loading_message"));
      notifySuccess(t("visa.loading_message"));

      setTimeout(() => {
       window.location.href ='/'
      }, 2000);
    } catch (error) {
      setLoadingMessage(t("visa.error_messages.login_required"));
      setTimeout(() => {
        // Handle error
      }, 2000);
      console.error('Error submitting form:', error);
    }
  };


  const numberOptions = Array.from({ length: 10 }, (_, i) => ({ value: i + 1, label: `${i + 1}` }));

  const steps = [
    { icon: <FaPlane />, label: t("visa.criteria_title") },
    { icon: <FaUsers />, label: t("visa.applicant_title", { index: 1 }).replace(/\s*#?\s*1\s*$/, '') },
    { icon: <FaShieldAlt />, label: t("visa.terms_title") },
  ];

  return (
    <div className="Page_visa" dir={isRTL ? "rtl" : "ltr"}>
      <Topbar />
      <Navbar page={"visa"} />
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={isRTL}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />

      {!loading ? (
        <>
          {/* ═══ Hero ═══ */}
          <section className="v-hero">
            <div className="v-hero__icon"><FaPassport /></div>
            <h1 className="v-hero__title">{t("visa.title")}</h1>
            <p className="v-hero__sub">{t("visa.important_note")}</p>

            <div className="v-steps">
              {steps.map((s, i) => (
                <div key={i} className="v-step">
                  <span className="v-step__dot">{s.icon}</span>
                  <span className="v-step__label">{s.label}</span>
                </div>
              ))}
            </div>
          </section>

          <main className="v-main">
            {/* Step 1 */}
            <section className="v-card">
              <div className="v-card__head">
                <span className="v-pill">
                  <span className="v-pill__num">1</span>
                  Step 1
                </span>
                <h2 className="v-card__title">{t("visa.criteria_title")}</h2>
              </div>

              <div className="v-form">
                <VField icon={FaUsers} label={t("visa.no_persons_label")}>
                  <select className="v-select" value={nopersonne} onChange={handleNumberOfPersonsChange}>
                    {numberOptions.map((o) => (<option key={o.value} value={o.value}>{o.label}</option>))}
                  </select>
                </VField>
                <VField icon={FaFileAlt} label={t("visa.visa_type_label")}>
                  <select className="v-select" value={visatype.value} onChange={(e) => setVisatype(visaTypes.find(o => o.value === e.target.value))}>
                    {visaTypes.map((o) => (<option key={o.value} value={o.value}>{o.label}</option>))}
                  </select>
                </VField>
                <VField icon={FaGlobeAmericas} label={t("visa.destination_label")}>
                  <select className="v-select" value={paymentCountry.value} onChange={(e) => setPaymentCountry(countries.find(o => o.value === e.target.value))}>
                    {countries.map((o) => (<option key={o.value} value={o.value}>{o.label}</option>))}
                  </select>
                </VField>
                <VField icon={FaFlag} label={t("visa.nationality_label")}>
                  <select className="v-select" value={nationality.value} onChange={(e) => setNationality(nationalities.find(o => o.value === e.target.value))}>
                    {nationalities.map((o) => (<option key={o.value} value={o.value}>{o.label}</option>))}
                  </select>
                </VField>
                <VField icon={FaIdCard} label={t("visa.travel_document_label")}>
                  <select className="v-select" value={documentTypev.value} onChange={(e) => setDocumentType(documentTypes.find(o => o.value === e.target.value))}>
                    {documentTypes.map((o) => (<option key={o.value} value={o.value}>{o.label}</option>))}
                  </select>
                </VField>
                <VField icon={FaCalendarAlt} label={t("visa.travel_start_date_placeholder")}>
                  <div className="v-date">
                    <DatePicker
                      selected={startDate ? new Date(startDate) : null}
                      onChange={(date) => setStartDate(date.toISOString().split("T")[0])}
                      placeholderText={t("visa.travel_start_date_placeholder")}
                      dateFormat="yyyy-MM-dd"
                      minDate={new Date()}
                      required
                    />
                  </div>
                </VField>
              </div>
            </section>

            {/* Step 2 */}
            <section className="v-card">
              <div className="v-card__head">
                <span className="v-pill">
                  <span className="v-pill__num">2</span>
                  Step 2
                </span>
                <h2 className="v-card__title">{t("visa.applicant_title", { index: nopersonne }).replace(/\s*\d+\s*$/, '')}</h2>
              </div>

              <div className="v-applicants">
                {applicants.map((applicant, index) => (
                  <ApplicantForm
                    key={index}
                    index={index}
                    onChange={handleApplicantChange}
                    values={applicant}
                  />
                ))}
              </div>
            </section>

            {/* Step 3 */}
            <section className="v-card">
              <div className="v-card__head">
                <span className="v-pill">
                  <span className="v-pill__num">3</span>
                  Step 3
                </span>
                <h2 className="v-card__title">{t("visa.terms_title")}</h2>
              </div>

              <div className="v-banner v-banner--info">
                <FaInfoCircle className="v-banner__icon" />
                <p>{t("visa.important_note")}</p>
              </div>

              <div className="v-terms">
                {t("visa.terms_content", { returnObjects: true }).map((term, i) => (
                  <div key={i} className="v-term">
                    <FaCheckCircle className="v-term__icon" />
                    <p>{term}</p>
                  </div>
                ))}
              </div>

              <label className={`v-accept ${acceptedTerms ? 'v-accept--checked' : ''}`}>
                <input
                  type="checkbox"
                  checked={acceptedTerms}
                  onChange={(e) => setAcceptedTerms(e.target.checked)}
                />
                <span className="v-accept__box" />
                <span className="v-accept__text">
                  {t("visa.accept_terms_label")}{" "}
                  <a href="#" onClick={(e) => { e.preventDefault(); setIsPrivacyModalOpen(true); }}>
                    {t("visa.privacy_policy_link")}
                  </a>
                </span>
              </label>

              {errormessage && (
                <div className="v-banner v-banner--error">
                  <FaInfoCircle className="v-banner__icon" />
                  <p>{t(`visa.error_messages.${errormessage}`)}</p>
                </div>
              )}

              <div className="v-submit">
                <p className="v-submit__note">{t("visa.payment_info")}</p>
                <button className="v-submit__btn" onClick={handleSubmit} disabled={!acceptedTerms}>
                  <FaCheckCircle /> {t("visa.submit_button")}
                </button>
              </div>
            </section>
          </main>
        </>
      ) : (
        <div className="v-loader">
          <ClipLoader color={"#239efe"} loading={loading} size={60} />
          <p>{t("visa.loading_message")}</p>
        </div>
      )}

      <Footer />
      <PrivacyTermsModal
        isOpen={isPrivacyModalOpen}
        onClose={() => setIsPrivacyModalOpen(false)}
        onAccept={() => { setPrivacyAccepted(true); setAcceptedTerms(true); setIsPrivacyModalOpen(false); }}
      />
    </div>
  );
}